import { pick, get } from 'lodash';

export default class {
  constructor(response = {}) {
    this.response = response;
  }

  get jumpstartInfo() {
    return get(this.response, 'data.attributes.jumpstart_info', {});
  }

  get adUnitAttributes() {
    const { jam_prefix: prefix, source, focus, condition } =
      this.jumpstartInfo.jam_unit_attributes || {};

    return { prefix, source, focus, condition };
  }

  get targeting() {
    return pick(
      this.jumpstartInfo,
      '',
      'mak',
      'mod',
      'pub',
      'style',
      'type',
      'yr'
    );
  }
}
